import React from 'react'
import { Paper } from '@material-ui/core'
import './SkyPaper.scss'
var classNames = require('classnames')

export const SkyPaper = ({ children, small, isHighlighted, className, showHover, ...props }) => {
  return (
    <Paper
      className={classNames(
        className,
        { 'with-hover': showHover },
        { highlighted: isHighlighted },
        { 'sky-paper-container': !small },
        { 'sky-paper-container-small': small }
      )}
      {...props}
    >
      {children}
    </Paper>
  )
}
